export const USERS_LIST = "USERS_LIST"
export const USERS_LIST_SUCCESS = "USERS_LIST_SUCCESS"
export const USERS_LIST_ERROR = "USERS_LIST_ERROR"

export const USERS_NEW = "USERS_NEW"
export const USERS_NEW_SUCCESS = "USERS_NEW_SUCCESS"
export const USERS_NEW_ERROR = "USERS_NEW_ERROR"

export const USERS_EDIT = "USERS_EDIT"

export const USERS_DELETE = "USERS_DELETE"
export const USERS_DELETE_SUCCESS = "USERS_DELETE_SUCCESS"
export const USERS_DELETE_ERROR = "USERS_DELETE_ERROR"

export const USERS_BLOCK = "USERS_BLOCK"
export const USERS_BLOCK_SUCCESS = "USERS_BLOCK_SUCCESS"
export const USERS_BLOCK_ERROR = "USERS_BLOCK_ERROR"
